import { Navigate } from 'react-router-dom'
import { useTenant } from '../../hooks/useTenant'
import { useAuth } from '../../contexts/AuthContext'
import { useImpersonation } from '../../contexts/ImpersonationContext'

/**
 * Guard che protegge le rotte dashboard: se l'onboarding non è completato,
 * reindirizza a /onboarding. Montato dentro AppShell (dopo ProtectedRoute).
 */
export function OnboardingGuard({ children }: { children: React.ReactNode }) {
  const { user, loading: authLoading } = useAuth()
  const { impersonation } = useImpersonation()
  // Durante impersonazione non c'è sessione Supabase: useTenant userebbe !!user=false
  const enabled = !!user || !!impersonation
  const { data: tenant, isPending, isError, error } = useTenant(enabled)

  // Sessione di impersonazione — il tenant esiste per definizione, bypass
  if (impersonation) return <>{children}</>

  // Attendi che auth E tenant siano pronti prima di decidere
  // isPending (RQ v5) = query non ancora completata, anche prima che il fetch inizi
  if (authLoading || isPending) {
    return (
      <div className="min-h-screen bg-[--km-bg-deep] flex items-center justify-center">
        <p className="text-sm text-[--km-text-muted]">Caricamento…</p>
      </div>
    )
  }

  // Errore API generico (rete, 500, ecc.) → fail-open, mostra la dashboard
  // Solo un 404 confermato ("Tenant non trovato") manda all'onboarding
  if (isError) {
    const is404 = error?.message?.includes('404') || error?.message?.includes('Tenant non trovato')
    if (!is404) return <>{children}</>
    return <Navigate to="/onboarding" replace />
  }

  // Dati presenti ma onboarding non completato → wizard
  if (!tenant?.settings?.onboarding_completed) {
    return <Navigate to="/onboarding" replace />
  }

  return <>{children}</>
}
